import { Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { PUBLIC_ROUTES } from "@/shared/constants/paths";

// Public Pages
import { MobileUploadPage } from "@/pages/public/mobile-upload/MobileUploadPage";
import { DocumentRequestPage } from "@/pages/public/document-request/DocumentRequestPage";

export const publicRoutes = (
  <>
    <Route
      path={PUBLIC_ROUTES.MOBILE_UPLOAD}
      element={
        <>
          <Helmet>
            <title>Mobile Upload - Elayne</title>
          </Helmet>
          <MobileUploadPage />
        </>
      }
    />
    <Route
      path={PUBLIC_ROUTES.DOCUMENT_REQUEST}
      element={
        <>
          <Helmet>
            <title>Document Request - Elayne</title>
          </Helmet>
          <DocumentRequestPage />
        </>
      }
    />
  </>
);
